export default {
  state: {
    colors: Set
  },
  actions: {
    setColors ({ commit }, payload) {
      commit('SET_COLORS', payload)
    }
  },
  getters: {
    colors: (state) => state.colors
  },
  mutations: {
    SET_COLORS (state, value) {
      state.colors = value
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/colors/index.js